"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = optionFilling;

// option filling middlewares
// @author Pluto <huarse@gmail.com>
// @create 2020/01/05 15:05
async function optionFilling(ctx) {
  ctx.data = ctx.data || ctx.params || ctx.query;
  ctx.headers = ctx.headers || {};
  ctx.meta = ctx.meta || {};
  ctx.origin = {
    api: ctx.api,
    data: ctx.data
  };
  await ctx.next();
}